// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { creditCardDetailsEntryStyles } from "@turnerBlueprint/Overrides/Widgets/CheckoutReviewAndSubmit/CreditCardDetailsEntry";
import IconQuestion from "@turnerBlueprint/XDL/Icons/IconQuestion";
import { createLinkIconStyles } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

creditCardDetailsEntryStyles.creditCardDetailsContainer = {
    gap: 12,
};

creditCardDetailsEntryStyles.expirationDateContainer = {
    css: css`
        display: flex;
        column-gap: 22px;
        max-width: 317px;
    `,
};

creditCardDetailsEntryStyles.expirationYearSelect = {
    cssOverrides: {
        formField: css`
            margin-top: 19px;
        `,
    },
};

creditCardDetailsEntryStyles.hintLink = {
    ...createLinkIconStyles(IconQuestion, {
        css: css`
            &&& {
                &,
                &:hover {
                    display: inline-block;
                    height: 13px;
                }
            }
            ${IconWrapper} {
                position: relative;
                top: -2px;
                margin-left: 8px;
                &,
                & svg {
                    height: auto;
                    width: 16px;
                    opacity: 1;
                }
            }
        `,
    }),
};
